import { is, allPass, compose, equals, length, slice } from 'ramda';

const validate = allPass([is(String), compose(equals(11), length)]);

export const getGender = ssn => {
  if (!validate(ssn)) return null;
  const genderN = slice(7, 10, ssn) & 1;
  return genderN === 0 ? 'female' : genderN === 1 ? 'male' : null;
};
